/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */


module.exports = {
    path: 'contractor-rating/:token',
    getComponent(nextState, callback) {
        require.ensure([], (require) => {
      		callback(null, require('./ContractorRatingContainer'));
    	});
    }
};



// WEBPACK FOOTER //
// ./src/app/components/contractor-rating/route.ContractorRating.js